import * as React from 'react';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

const FormSwitch = React.forwardRef(({ className, label, id, ...props }, ref) => {
  const compId = React.useId();

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Switch
        id={id ?? compId}
        ref={ref}
        {...props}
      />
      {label && (
        <Label
          htmlFor={id ?? compId}
          className="font-light text-primary-dark"
        >
          {label}
        </Label>
      )}
    </div>
  );
});
FormSwitch.displayName = 'FormSwitch';

export { FormSwitch };
